import { isNumber, isString, isUnknownObject } from '~/shared/utils/guards'
import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { toDateFormat } from '~/shared/utils/date'
import { AgrocityModel } from '~/models/agrocity'

export default class VacancyModel extends BaseModel {
  static override constructorName = 'VacancyModel'

  id: number = 0
  'vacancy_group_id': number = 0
  'vacancy_groups': string[] = []
  'vacancy_region_id': number = 0
  'vacancies_count': number = 0
  'vacancies_count_new': number = 0
  'vacancies_min_amount': number = 0
  'vacancies_max_amount': number = 0
  'vacancy_region': string = ''
  'created_at': string = ''
  'updated_at': string = ''
  'deleted_at': string = ''
  conditions: string = ''
  schedule: string = ''
  'education_value': string = ''
  name: string = ''
  slug: string = ''
  'region_name': string = ''
  'region_slug': string = ''
  'rabota_kem': string = ''
  'region_color': string = ''
  salary: number | string = 0
  'employer_slug': string = ''
  'organization_value': string = ''
  'organization_slug': string = ''
  'import_org_name': string = ''
  'import_vacancy_url': string | null = null
  'import_source_name': string | null = null
  'import_source_index': number = 0
  updated: string = ''
  responsibilities?: string = ''
  requirements: string = ''
  'workplace_value': string = ''
  'housing_value': string = ''
  'employment_value': string = ''
  path: string = ''
  'position_value': string = ''
  'external_id': string = ''
  'is_canonical': number = 0
  'status_code': number = 0
  'is_sended_response': boolean = false
  'is_vacancy_promotion': boolean = false
  'is_simple_feedback': boolean = false
  'is_accept_handicapped': boolean = false
  'is_deleted': boolean = false
  'company_logo': string = ''
  'link_to_vacancies': string = ''
  'foreign_worker': boolean = false
  'experience_value': string = ''
  'region_value': string = ''
  'is_salary_hidden': boolean = false
  'internship_start_date': string = ''
  'internship_end_date': string = ''
  'internship_image': string = ''
  'internship_priority_values': string[] = []
  'employment_format_values': string[] = []
  'internship_expectation_values': string[] = []
  agrocity: AgrocityModel | null = null

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      if (isString(data.deleted_at)) {
        this.deleted_at = toDateFormat(data.deleted_at)
      }

      if (isNumber(data.salary)) {
        this.salary = String(data.salary)
      }

      if (data.agrocity) {
        this.agrocity = new AgrocityModel(data.agrocity)
      }
    }
  }
}

registerModel(VacancyModel)
